
import images from "./images";

type IndustryItem = {
  source?: any;
  icon?: string;
  sTitle: string;
};

type IndustriesData = {
  [key: string]: IndustryItem[];
};

export const industriesData: IndustriesData = {
  incomingWA: [{
    source: images.WAPPWF,
    sTitle: "Incoming WhatsApp",
  }],
  incomingWebhook: [
    {
      sTitle: "Incoming Webhook",
      source: images.WebhookIcon,
    }
  ],
  facebookLead: [{
    sTitle: "Facebook Lead",
    source: images.FBWF,
  }],
  shopify: [{
    source: images.SHOPIFYLOGONEW,
    sTitle: "Shopify Event",
  }],
  campaign: [{
    source: images.CampaignIcon,
    sTitle: "Campaign Sent"
  }],
  pabblyEvent: [{
    source: images.PabblyTag,
    sTitle: "Pabbly Event"
  }
  ],
  instagramEvent: [{
    source: images.InstaIcon,
    sTitle: "Instagram"
  }],
  formsWFNode: [{
    source: images.EmbeddedForm,
    sTitle: "Embedded Form"
  }],
  contactWFNode: [{
    source: images.NewContactIcon,
    sTitle: "New Contact Added"
  }],
  wooWFNode: [{
    source: images.woocom,
    sTitle: "WooCommerce Event"
  }],
  kylasUpdate : [{
    source: images.Kylas,
    sTitle: "Kylas Event Update"
  }],
    kylasCreate : [{
    source: images.KylasWorkflow,
    sTitle: "Kylas Event Create"
  }],

}

interface WorkflowTemplate {
    _id?: string;
    id?: string | number;
    title: string;
    description: string;
    source: string;
    sTitle: string;
    tags: string[];
    libMapName?: string;
    name?: string;
    category?: string;
}

export const workflowTemplates: Record<string, WorkflowTemplate[]> = {
    Ecommerce: [
        {
            _id: "68bad22e5052e8fda4cce3df",
            title: "Abandoned Cart Follow up",
            description: "7 out of 10 shopping carts are abandoned. Recover more of them and drive up sales with this basic pre-built abandoned cart series.",
            source: images.SHOPIFYLOGONEW,
            sTitle: "Shopify Event",
            tags: ['email', 'whatsapp'],
            libMapName: "Ecom-1"
        },
        {
            _id: "68bad74c5052e8fda4cce3e5",
            title: "Abandoned Cart Reminder",
            description: "7 out of 10 shopping carts are abandoned. Send an email and WhatsApp Reminder to the customers to complete the purchase.",
            source: images.SHOPIFYLOGONEW,
            sTitle: "Shopify Event",
            tags: ['email', 'whatsapp'],
            libMapName: "Ecom-2"
        },
        {
            _id: "68bad5775052e8fda4cce3e3",
            title: "Order Confirmation",
            description: "Keep customers updated with a WhatsApp message after a purchase is made using this flow. It’s pre-built to populate important order details.",
            source: images.SHOPIFYLOGONEW,
            sTitle: "Shopify Event",
            tags: ['email', 'whatsapp'],
            libMapName: "Ecom-3"
        },
        {
            _id: "68be5a15637404b22fad2231",
            title: "Order Fully Processed",
            description: "Keep customers updated with a WhatsApp message after their order is fully processed by the buyer.",
            source: images.SHOPIFYLOGONEW,
            sTitle: "Shopify Event",
            tags: ['email', 'whatsapp'],
            libMapName: "Ecom-4"
        },
        {
            _id: "68be6229637404b22fad2237",
            title: "Shipment Out for Delivery",
            description: "Using this flow, keep your customers updated each time a shipment from their order is out for delivery. It’s prebuilt to populate important tracking details.",
            source: images.SHOPIFYLOGONEW,
            sTitle: "Shopify Event",
            tags: ['email', 'whatsapp'],
            libMapName: "Ecom-5"
        },
        {
            _id: "68be6374637404b22fad2239",
            title: "Order Cancelled",
            description: "Using this flow, notify your customers when their order has been cancelled. It’s pre-built to populate important order details.",
            source: images.SHOPIFYLOGONEW,
            sTitle: "Shopify Event",
            tags: ['email', 'whatsapp'],
            libMapName: "Ecom-6"
        },
    ],
    Banking: [
        {
            _id: "68be69db637404b22fad223b",
            title: "Payment Reminders",
            description: "Most of the customers forget to repay their EMIs and Payment. Send a reminder messages to optimize cashflow",
            source: images.WebhookIcon,
            sTitle: "Incoming Webhook",
            tags: ["whatsapp"],
            libMapName: "Banking-1"
        },
        {
            _id: "68be6b49637404b22fad223d",
            title: "Eligibility Check",
            description: "Setup and automate the eligibility criteria for loans and Credit Cards with help of WhatsApp. Just collect information on WhatsApp",
            source: images.WebhookIcon,
            sTitle: "Incoming Webhook",
            tags: ["whatsapp"],
            libMapName: "Banking-2"
        },
        {
            _id: "68be6f22637404b22fad223f",
            title: "Transactional Messages",
            description: "Using this flow, you can send automated transactional message like UPI Payments, Card payments etc.",
            source: images.WebhookIcon,
            sTitle: "Incoming Webhook",
            tags: ["email", "sms", "whatsapp"],
            libMapName: "Banking-3"
        },
        {
            _id: "68be706b637404b22fad2241",
            title: "Customer Support",
            description: "Using this flow, provide a full on-hand support to your customers on WhatsApp. Customize as per the support goal.",
            source: images.WAPPWF,
            sTitle: "Incoming WhatsApp",
            tags: ["whatsapp"],
            libMapName: "Banking-4"
        },
        {
            _id: "68bf0251637404b22fad2278",
            title: "KYC Verification Appointment",
            description: "Using this flow, your customers can schedule a KYC Verification Appointment directly from WhatsApp.",
            source: images.WAPPWF,
            sTitle: "Incoming WhatsApp",
            tags: ["whatsapp"],
            libMapName: "Banking-5"
        },
    ],
    Education: [
        {
            _id: "68be75c9637404b22fad2245",
            title: "Admission Registration ",
            description: "Using this flow, you can simplify your admission registration process with real-time data collection and updation.",
            source: images.WAPPWF,
            sTitle: "Incoming WhatsApp",
            tags: ["whatsapp"],
            libMapName: "Edu-1"
        },
        {
            _id: "68be7786637404b22fad2247",
            title: "Admission Enquiry",
            description: "Using this flow, setup an automated admission enquiry flow for your prospects. They can enquire, interact & experience on WhatsApp",
            source: images.WAPPWF,
            sTitle: "Incoming WhatsApp",
            tags: ["whatsapp"],
            libMapName: "Edu-2"
        },
        {
            id: "68be787d637404b22fad2249",
            title: "Student/ Parental Support",
            description: "Using this flow, provide a full on-hand support to your students and parents on WhatsApp. Customize as per the support goal.",
            source: images.WAPPWF,
            sTitle: "Incoming WhatsApp",
            tags: ["whatsapp"],
            libMapName: "Edu-3"
        },
        {
            _id: "68be7976637404b22fad224b",
            title: "Admission Follow up",
            description: "Using this flow, Nurture your prospects with personalized follow ups and interaction over an email, WhatsApp.",
            source: images.FBWF,
            sTitle: "Facebook Lead",
            tags: ["sms", "whatsapp"],
            libMapName: "Edu-4"
        },
    ],
    Realestate: [
         {
            _id: "68c3c9ef91a4a36e76bedda7",
            title: "Registration",
            description: "Allow potential buyers or renters to register directly through WhatsApp. This workflow collects their details and confirms successful registration for further updates",
            source: images.WAPPWF,
            sTitle: "Incoming WhatsApp",
            tags: ["email", "whatsapp"],
            libMapName: "Estate-4"
        },
        {
            _id: "68be7b69637404b22fad224d",
            title: "General Enquiry",
            description: "Handle real estate enquiries smoothly via WhatsApp. This workflow captures user details, processes their questions with AI assistance, and assigns them to an agent when needed.",
            source: images.WAPPWF,
            sTitle: "Incoming WhatsApp",
            tags: ["whatsapp"],
            libMapName: "Estate-2"
        },
        {
            _id: "68be7cd9637404b22fad224f",
            title: "Customer Support",
            description: " Provide instant support to property seekers through WhatsApp. This workflow answers questions with AI, allows escalation to human agents, and enables users to track the status of their requests.",
            source: images.WAPPWF,
            sTitle: "Incoming WhatsApp",
            tags: ["whatsapp"],
            libMapName: "Estate-3"
        },
        {
            _id: "68be7d78637404b22fad2251",
            title: "Lead Follow up",
            description: "Using this flow, Nurture your prospects with personalized follow ups and interaction over an email, WhatsApp",
            source: images.FBWF,
            sTitle: "Facebook Lead",
            tags: ["email", "whatsapp"],
            libMapName: "Estate-4"
        },
    ],
    Healthcare: [
        {
            _id: "68b93da58bdb4c2e16e6cbe7",
            title: "General Appointment Booking",
            description: "Enable patients or customers to book appointments via WhatsApp easily. This workflow provides options for booking, support, or learning more about your services, with smooth escalation to agents when required",
            source: images.WAPPWF,
            sTitle: "Incoming WhatsApp",
            tags: ["whatsapp"],
            libMapName: "Health-1"
        },
        {
            _id: "68be7f79637404b22fad2253",
            title: "General Enquiry",
            description: "Handle healthcare-related enquiries efficiently on WhatsApp. This workflow collects patient details, provides automated responses using AI, and escalates to a human agent when necessary.",
            source: images.WAPPWF,
            sTitle: "Incoming WhatsApp",
            tags: ["whatsapp"],
            libMapName: "Webinar-2"
        },
        {
            _id: "68be805c637404b22fad2255",
            title: "Customer Support",
            description: "Provide instant healthcare support on WhatsApp by answering common questions, offering AI-powered assistance, assigning agents for complex cases, and enabling patients to track their requests or appointments.",
            source: images.WAPPWF,
            sTitle: "Incoming WhatsApp",
            tags: ["whatsapp"],
            libMapName: "Health-3"
        },
        {
            _id: "68c3cb1791a4a36e76bedda9",
            title: "Doctor’s Appointment Booking",
            description: "Allow patients to easily book doctor consultations through WhatsApp. This workflow provides quick options for appointment booking, support, or service information, while collecting necessary patient details for scheduling.",
            source: images.WAPPWF,
            sTitle: "Incoming WhatsApp",
            tags: ["whatsapp"],
            libMapName: "Health-4"
        },
        {
            _id: "68be81c2637404b22fad2257",
            title: "Lead Follow up",
            description: " Nurture new healthcare leads from Facebook Ads by sending a sequence of WhatsApp messages at timed intervals. This workflow ensures timely engagement and increases the chances of converting leads into patients.",
            source: images.FBWF,
            sTitle: "Facebook Lead",
            tags: ["email", "whatsapp"],
            libMapName: "Health-5"
        },
    ],
    Webinar: [
        {
            _id: "68be828e637404b22fad2259",
            title: "Webinar Registration",
            description: "Automate webinar sign-ups directly through WhatsApp. Collect participant details like name, phone number, and email, and confirm their registration instantly.",
            source: images.WAPPWF,
            sTitle: "Incoming WhatsApp",
            tags: ["whatsapp"],
            libMapName: "Webinar-1"
        },
        {
            _id: "68be8333637404b22fad225b",
            title: "General Enquiry",
            description: "Using this flow, setup an automated enquiry flow for your prospects. They can enquire, interact & experience on WhatsApp",
            source: images.WAPPWF,
            sTitle: "Incoming WhatsApp",
            tags: ["whatsapp"],
            libMapName: "Webinar-2"
        },
        {
            _id: "68c3c7f691a4a36e76bedda5",
            title: "Webinar Follow up",
            description: "Using this flow, Nurture your prospects with personalized follow-ups and interaction over email, WhatsApp",
            source: images.FBWF,
            sTitle: "Lead from Facebook Ad",
            tags: ["email", "whatsapp"],
            libMapName: "Webinar-3"
        },
        {
            _id: "68be847a637404b22fad225d",
            title: "Webinar Feedback collection",
            description: "Collect structured feedback from webinar participants via WhatsApp. This workflow captures attendee details, ratings, opinions, and suggestions to help improve future webinars.",
            source: images.WAPPWF,
            sTitle: "Incoming WhatsApp",
            tags: ["whatsapp"],
            libMapName: "Webinar-4"
        },
    ],
    all: [

    ]

};